<template>
    <div>
        <el-drawer :append-to-body="true" :visible.sync="drawer" :before-close="handleClose" size="500px" class="drawer-data-form-20210720">
          <div>
            <BjDivider>{{ $t('CustomerFunction.onboardingFiles') }}</BjDivider>
            <BjPage ref="BjPage" style="margin-top: -40px;" :get-action="queryApi" :query-params="queryParams" :serial="serial" :selection="selection" :search-btn-hide="true"
              @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" 
              @header-contextmenu="SortableTable.handleHeaderContextmenu" @afterFetchOriginalData="afterFetchOriginalData"
            >
              <template v-slot:tableOperation="tableOperationProp">
                  <el-col>
                      <el-button :disabled="tableOperationProp.notSelected" type="primary" class="main-btn" @click="batchDownload()">{{$t('batchDownloadText')}}</el-button>
                  </el-col>
              </template>
              <template v-slot:tableColumn>
                <template v-for="(col, index) in dropCols">
                  <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
                    <template slot-scope="scope">
                      <template v-if="false" />
                      <template v-else-if="col.prop === 'profitMargin'">
                          <span>{{ scope.row[col.prop] }} %</span>
                      </template>
                      <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
                    <template slot-scope="props">
                        <el-button type="text" size="small" @click="downloadImageUrl(props.row.url, props.row.name)">{{ $t('downloadText') }}</el-button>
                    </template>
                  </el-table-column>
                </template>
              </template>
            </BjPage>
          </div>
        </el-drawer>
    </div>
</template>

<script>
import pageMiXin from '@/utils/page-mixin.js';
import { funConfigApi } from '@/api';
import JSZip from 'jszip';

export default {
    mixins: [pageMiXin],
    data() {
        return {
            colSpan: 4,
            selection: true,
            drawer: false,
            innerDrawer: false,
            queryApi: funConfigApi.getOnboardingDetail,
            queryParams:{
                id:null,
            },
            labelList: [
                {label: this.$t('fileSearch.page.FileName'),prop: 'name',isCheck: true,disabled: false,},
                {label: this.$t('table.operationText'),prop: 'bjTableAction',isCheck: true,disabled: false,width: 160,},
            ],
        };
    },
    methods: {
      // 过滤接口数据
      afterFetchOriginalData(res) {
        this.$nextTick(() => {
          this.$refs.BjPage.tableData = res.allFileList;
        });
      },
      // 批量下载
      async batchDownload() {
        if (this.selectedRows.some(item => this.isCrossDomainDownloadUrl(item.url))) {
            this.selectedRows.forEach(item => this.downloadImageUrl(item.url, item.name));
            return;
        }
        const zip = new JSZip();
        for (const item of this.selectedRows) {
            const response = await fetch(this.normalizeDownloadUrl(item.url));
            const blob = await response.blob();
            zip.file(`${item.name}`, blob);
        }
        zip.generateAsync({ type: 'blob' })
          .then(function(content) {
            const url = window.URL.createObjectURL(content);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'onboardingFiles.zip');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        });
      },
      handleClose() {
        this.drawer = false
      },
    },
};
</script>
<style lang="scss">
/***/
.drawer-data-form-20210720 {
  .el-drawer__container {
    padding: 8px;
  }
  .el-drawer__header {
    margin-bottom: 4px;
  }
  .el-drawer__body {
    padding: 16px;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .el-drawer__body form {
    flex: 1;
    max-height: 100%;
    overflow-y: auto;
    padding: 16px;
  }
  .el-drawer__body .footer button {
    width: 200px;
  }
  .footer.has-title {
    margin-bottom: 45px;
  }
}
</style>
